<template>
	<div id="Main">
		<div class="box" v-if="!upload">
			<p class="name">股权过入</p>
			<p class="warning">下列信息有 * 为必填项</p>
			<div class="form">
				<div class="inputbox">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>企业简称</span><span class="ico">*</span>
					</div>
					<van-field class="input" type="text" v-model="companyShortName" placeholder="请填写企业简称" />
				</div>
				<div class="inputbox">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/account_1.png')" />
						<span>企业代码</span><span class="ico">*</span>
					</div>
					<van-field class="input" @input="getmoeny" type="number" v-model="companyCode" placeholder="请填写企业代码"/>
				</div>
				<div class="inputbox">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过户数量</span><span class="ico">*</span>
						<div class="money" v-if="money>0">预计费用:{{money.toFixed(2)}}元</div>
					</div>
					<van-field class="input" @input="change" type="number" v-model="transferNum" placeholder="请填写过户数量" />
				</div>
				<div class="inputbox" @click="show2=true">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过户原因</span>
					</div>
					<van-field class="input" type="text" :value="transferReason" placeholder="请选择过户原因">
						<van-icon slot="button" class="select" name="play" />
					</van-field>
				</div>
				<div class="inputbox">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过出方姓名</span><span class="ico">*</span>
					</div>
					<van-field class="input" type="text" v-model="comeName" placeholder="请填写过入方姓名" />
				</div>
				<div class="inputbox" @click="show3=true">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过出方证件类型</span>
					</div>
					<van-field class="input" type="text" :value="comeIdcardType" placeholder="请选择身份证/营业执照">
						<van-icon slot="button" class="select" name="play" />
					</van-field>
				</div>
				<div class="inputbox">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过出方证件号码</span><span class="ico">*</span>
					</div>
					<van-field class="input" type="number" v-model="comeIdcard" placeholder="请填写过入方证件号码" />
				</div>
				<div class="inputbox">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过出方账户号</span><span class="ico">*</span>
					</div>
					<van-field class="input" type="number" v-model="comeUsername" placeholder="请输入过户方账号" />
				</div>
			</div>
		</div>
		<van-button round type="info" v-if="!upload" class="submit" @click="next">下一步</van-button>
		<van-popup v-model="show2" position="bottom" style="height: 40%">
			<van-picker :columns="picker2" @cancel="show2=false" @confirm="confirm2" :show-toolbar="true" />
		</van-popup>
		<van-popup v-model="show3" position="bottom" style="height: 40%">
			<van-picker :columns="picker3" @cancel="show3=false" @confirm="confirm3" :show-toolbar="true" />
		</van-popup>
		<uploadimg v-if="upload" :type="2" @submit="submit"></uploadimg><!-- 上传图片组件 -->
	</div>
</template>
<script>
	import uploadimg from '../../components/transfer';
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {
			uploadimg
		},
		data() {
			return {
				cost1:'',//费用2
				cost2:'',//费用2
				money:0,//预计费用
				upload: false,
				/* 第二步 */
				show2: false,
				show3: false,
				picker2: ['继承','赠与', '财产分割', '协议转让'],/* 过户原因 */
				picker3: ['身份证', '营业执照'],/* 过户证件类型 */
				transferReason: '',/* 过户原因 */
				user: '',/* 账户 */
				name: '',/* 姓名 */
				transferNum: '',/* 可用数量 */
				comeIdcardType: '',/* 证件类型 */
				comeName: '',/* 过入方姓名 */
				comeIdcard: '',/* 过入方证件号码 */
				comeUsername: '' ,/*, 过入方账户号 */
				companyCode:'',/* 企业代码 */
				companyShortName:'',/* 企业简称 */
			}
		},
		methods: {
			next() {
				if (this.companyCode == '' || this.companyShortName == '' || this.transferNum == '' || this.comeName == '' || this.comeIdcard == '' || this.comeUsername == '') {
					this.$toast({duration:4000,message:'请填写必填项！'});
				} else {
					this.upload = true
				}
			},
			confirm3(value) {
				this.comeIdcardType = value
				this.show3 = false
			},
			confirm2(value) {
				this.transferReason = value
				this.show2 = false
			},
			change(e) { /* 质押数量大小限制 */
				if (e <= 0) {
					this.$toast({duration:4000,message:'过户数量不能为小于0！'});
					this.transferNum = 1;
				}
				this.money=this.transferNum * this.cost1 + this.cost2
			},
			submit(e) { /* 过户提交 */
				window.console.log(e)
				let formdata = {
					shareholdeCode: this.user,/* 股东代码 */
					shareholdeName: this.name,/* 股东姓名 */
					companyCode: this.companyCode,/* 企业代码 */
					companyShortName: this.companyShortName,/* 企业简称 */
					transferNum: this.transferNum,/* 过户数量 */
					img: e,/* 申请图片（注销登记通知书等） */
					bussinessType:3,/* 类型 */
					transferReason: this.transferReason ,/* 过户原因 */
					comeName: this.comeName ,/* 过入姓名 */
					comeIdcardType: this.comeIdcardType ,/* 过入证件类型 */
					comeIdcard: this.comeIdcard ,/* 过入证件号 */
					comeUsername: this.comeUsername ,/* 过入账户号 */
				}
				localStorage.setItem('formdata', JSON.stringify(formdata))
				this.$router.push({
					path: '/formdata'
				})
			},
			getmoeny(id){
				axiosPost.getmoeny({companyCode:id}).then((res) => {
					if(res.data.code==200 && res.data.data && res.data.data.cost1 && res.data.data.cost2){
						this.cost1= res.data.data.cost1
						this.cost2= res.data.data.cost2;
						if(this.transferNum){
							this.money=this.transferNum * this.cost1 + this.cost2
						}
					}else{
						this.getmoeny(0);
					}
				}).catch((res) => {
					this.intercept=true
					window.console.log(res)
				})
			}
		},
		mounted() {
			this.user = this.$route.query.user
			this.name = this.$route.query.name
		}
	}
</script>

<style lang="scss" scoped>
	.money{
		float: right;
		color: #323233;
		font-size:1.4rem ;
	}
	#Main {
		padding: 1.3rem;
		min-height: 100vh;
		background-color: #f2f9ff;
		.submit {
			width: 90%;
			display: block;
			margin: 2rem auto;
			background-color: #fa6b6b;
			border: 0;
			box-shadow: 0 3px 8px 1px #e8eaee;
		}
		.form {
			padding-bottom: 2rem;
			.inputbox {
				padding: 1rem 0;
				padding-left: 3rem;

				.input {
					flex: 1;
					padding: 0;
					height: 4rem;
					line-height: 4rem;
					border-bottom: 1px solid #e0dfdf;

					&:not(:last-child):after {
						display: none;
					}
				}
				.select{
					color: #a0a0a0;
				}
			}

			.title {
				text-align: left;
				line-height: 2.5rem;
				margin-left: -2.3rem;

				span {
					font-weight: bold;
					font-size: 1.6rem;
					color: #333;
				}

				.ico {
					color: #fa6b6b;
					display: inline-block;
					margin-left: 5px;
				}

				.icon {
					vertical-align: -0.25rem;
					margin-right: 0.8rem;
				}
			}
		}

		.box {
			background-color: #fff;
			border-radius: 8px;
			padding: 0 1rem;
			margin-bottom: 2rem;
			box-shadow: 0 2px 5px 1px #e4ebfa;

			.warning {
				font-size: 1.4rem;
				color: #fa6b6b;
				text-align: left;
				margin-bottom: 1rem;
			}

			.name {
				text-align: left;
				font-size: 1.8rem;
				color: #333;
				line-height: 3.5rem;
				padding-top: 0.6rem;
				font-weight: bold;
			}
		}
	}
</style>
